import { trainingMessagesShared } from './shared/training-messages';

export const modelImageListViewTexts = {
  trainButton: '学習する',
  retrainButton: '再学習する',
  numAnnotated: (all: number, numAnnotated: number) =>
    `${all}枚中${numAnnotated}枚アノテーション済み`,
  hideAnnotated: '未アノテーション画像のみ表示',
  showAll: 'すべて表示',
  isAnnotated: 'アノテーション済み',
  isBuklDelete: '一括削除',
  messages: {
    modelIsAvailable: [trainingMessagesShared.modelIsAvailable],
    annotationCompleted: trainingMessagesShared.annotationCompleted,
    annotationInCompleted: trainingMessagesShared.annotationIncomplete,
    noLabelRegistered: trainingMessagesShared.noLabelRegistered,
    trainingError: [trainingMessagesShared.trainingError],
    trainingRunning: trainingMessagesShared.trainingRunning,
    trainingRunningShort: '現在学習中です。'
  }
} as const;
